module.exports = __webpack_public_path__ + "img/home-grid-info-b-grid-master.0bc8991b.png";